export const fullEditUpshiftersAndModeTestIds = {
  MUST_BE_21_SWITCH: 'full_edit_upshifters_and_mode_must_be_21_switch',
  UPSHIFT_TO_HIRE_SWITCH:
    'full_edit_upshifters_and_mode_upshift_to_hire_switch',
  AUTO_ACCEPT_SWITCH: 'full_edit_upshifters_and_mode_auto_accept_switch',
  AUTO_ACCEPT_FAVORED_CHECKBOX:
    'full_edit_upshifters_and_mode_auto_accept_favored_checkbox',
  AUTO_ACCEPT_WORKED_BEFORE_CHECKBOX:
    'full_edit_upshifters_and_mode_auto_accept_worked_before_checkbox',
  AUTO_ACCEPT_CERTIFICATES_CHECKBOX:
    'full_edit_upshifters_and_mode_auto_accept_certificates_checkbox',
  AUTO_ACCEPT_ONBOARDED_CHECKBOX:
    'full_edit_upshifters_and_mode_auto_accept_onboarded_checkbox',
}
